import React, { useState } from "react";
import Resume from "../../img/resume.png";
import { Link } from "react-router-dom";

const Tabs = () => {
  const [activeTab, setActiveTab] = useState(0);
  const tabs = [
    "Using Your Data",
    "Data Retention",
    "Sharing third party data",
    "Cookies Policy",
  ];

  return (
    <div
      className="w-full px-6 md:px-24 py-16 text-white"
      style={{
        background:
          "radial-gradient(93.96% 223.34% at -10.76% 33.62%, #07031C 0%, #241D49 30.52%, #07031C 64.32%)",
      }}
    >
      {/* Header */}
      <div className="text-left mb-12">
        <h2 className="text-[#F2C493] text-2xl md:text-4xl font-semibold font-istok mb-2">
          Privacy Policy
        </h2>
        <p className="text-white text-base md:text-lg font-light">
          We are committed to protecting your data
        </p>

        <button className="mt-4 px-6 py-2 bg-gradient-to-r from-[#F2C493] to-[#241D49] text-white font-semibold rounded-md shadow-md hover:opacity-90 transition-all">
          Read Full Policy
        </button>
      </div>

      {/* Main Outer Box */}
      <div className="w-full max-w-3xl mx-auto border border-white border-opacity-20 rounded-xl p-6 md:p-10">
        <h3 className="text-white text-xl md:text-2xl text-center font-semibold mb-6">
          How <span className="text-[#F2C493]">Capital Nest</span> Uses Your
          Data
        </h3>

        {/* Tabs */}
        <div className="flex gap-2 justify-between overflow-x-auto whitespace-nowrap scrollbar-hide mb-8">
          {tabs.map((tab, index) => (
            <button
              key={index}
              className={`text-xs md:text-sm px-2 md:px-4 py-2 font-medium transition-all duration-300 ${
                activeTab === index
                  ? "text-[#F2C493] border-b-2 border-[#F2C493]"
                  : "text-white hover:text-[#F2C493]"
              }`}
              onClick={() => setActiveTab(index)}
            >
              {tab}
            </button>
          ))}
        </div>

        {/* Inner Bordered Box */}
        <div className="w-full border border-white border-opacity-10 rounded-lg p-6 md:p-8 flex flex-col md:flex-row gap-6 items-start">
          <div className="flex-1 text-white text-sm md:text-base leading-relaxed font-istok">
            {activeTab === 0 && (
              <p>
                Users are at the heart of everything we do. From the beginning,
                we’ve made user protection our top priority. That’s why we’ve
                embedded state-of-the-art security measures and strict data
                privacy controls across the entire Emerald Invest ecosystem.
              </p>
            )}
            {activeTab === 1 && (
              <p>
                We retain your data only as long as necessary for legitimate
                business or legal reasons. We ensure it’s securely stored and
                deleted once it's no longer needed.
              </p>
            )}
            {activeTab === 2 && (
              <p>
                We do not sell your data. Any sharing with third parties is
                strictly for services you agree to — like payment processing or
                compliance.
              </p>
            )}
            {activeTab === 3 && (
              <p>
                We use cookies to improve your experience, analyze traffic, and
                offer personalized content. You can manage cookie preferences
                anytime.
              </p>
            )}

            <Link
              to="#"
              className="inline-block mt-6 bg-[#D4F5F9] text-[#00001A] text-sm md:text-base font-medium px-6 py-3 rounded-[12px] hover:bg-opacity-80 transition-all"
            >
              See Full Privacy Policy Page
            </Link>
          </div>

          <div className="hidden md:block md:w-[150px] shrink-0">
            <img
              src={Resume}
              alt="Resume Illustration"
              className="w-full object-contain"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Tabs;
